export const PlanID = {
  /** Legacy id; maps to PLAN_STANDARD_100 from /plans API */
  BusinessMonthly: 'BUSINESS_MONTHLY',
};

/** Add-on IDs. ExtensionPremium maps to ADDON_PREMIUM from /plans API. */
export const AddonID = {
  ExtensionPremium: 'ADDON_PREMIUM',
  /** Synthetic add-on for standard tier (amount 0); not in API */
  ExtensionStandard: 'EXTENSION_STANDARD',
};

/** Mirrors Backend-payment/src/types/stripe.ts StripeSubscriptionStatus */
export enum StripeSubscriptionStatus {
  Active = 'active',
  Trialing = 'trialing',
  PastDue = 'past_due',
  Incomplete = 'incomplete',
  IncompleteExpired = 'incomplete_expired',
  Canceled = 'canceled',
  Unpaid = 'unpaid',
  Paused = 'paused',
}

export const STRIPE_SUBSCRIPTION_STATUS_LABELS: Record<StripeSubscriptionStatus, string> = {
  [StripeSubscriptionStatus.Active]: 'Active',
  [StripeSubscriptionStatus.Trialing]: 'Trialing',
  [StripeSubscriptionStatus.PastDue]: 'Past due',
  [StripeSubscriptionStatus.Incomplete]: 'Incomplete',
  [StripeSubscriptionStatus.IncompleteExpired]: 'Incomplete expired',
  [StripeSubscriptionStatus.Canceled]: 'Canceled',
  [StripeSubscriptionStatus.Unpaid]: 'Unpaid',
  [StripeSubscriptionStatus.Paused]: 'Paused',
};

export function isStripeSubscriptionStatus(value: unknown): value is StripeSubscriptionStatus {
  return typeof value === 'string' && Object.values(StripeSubscriptionStatus).includes(value as StripeSubscriptionStatus);
}

/** Statuses that block creating another subscription for the same business (mirrors Backend-payment). */
export const RUNNING_STRIPE_SUBSCRIPTION_STATUSES: readonly StripeSubscriptionStatus[] = [
  StripeSubscriptionStatus.Active,
  StripeSubscriptionStatus.Trialing,
  StripeSubscriptionStatus.PastDue,
  StripeSubscriptionStatus.Incomplete,
];

/** Statuses that grant paid feature access. */
export const ENTITLED_STRIPE_SUBSCRIPTION_STATUSES: readonly StripeSubscriptionStatus[] = [
  StripeSubscriptionStatus.Active,
  StripeSubscriptionStatus.Trialing,
];
